/** Single source of truth for keyboard shortcuts (drives the help dialog). */
export interface Shortcut {
  keys: string[];
  description: string;
}

export const SHORTCUTS: Shortcut[] = [
  { keys: ['←', '→'], description: 'Previous / next photo in the viewer' },
  { keys: ['Space'], description: 'Play / pause slideshow' },
  { keys: ['Esc'], description: 'Close viewer or clear selection' },
  { keys: ['?'], description: 'Show this help' },
  { keys: ['G'], description: 'Grid view' },
  { keys: ['L'], description: 'List view' },
  { keys: ['T'], description: 'Toggle light / dark theme' },
];
